import { render, staticRenderFns } from "./NgrgForm.vue?vue&type=template&id=65942a11&"
import script from "./NgrgForm.js?vue&type=script&lang=js&"
export * from "./NgrgForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports